import React, { useMemo } from "react";
import Styles from "./style.module.scss";
import Searchbar from "@Atom/Searchbar";
import { useState } from "react";
import Table from "@Molecule/Table";
import useWindowSize from "@Hooks/useWindowSize";

export default function StudentListAdmin({ data }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const { width } = useWindowSize();

  const template = useMemo(() => {
    return {
      data: data.data,
      columns: [
        {
          name: "name",
          width: width > 768 ? "455px" : "200px",
          title: "Nama Peserta",
        },
        {
          name: "voucher",
          title: "Kode Voucher",
        },
        {
          name: "preTest",
          title: "Pretest",
          renderData: (row) => <span>{row.preTest}</span>,
        },
        {
          name: "postTest",
          title: "Post Test",
          renderData: (row) => <span>{row.postTest}</span>,
        },
        {
          name: "",
          title: "Progress",
          hideOnMobile: true,
          renderData: (row) => <span>{row.progress}</span>,
        },
      ],
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width]);
  return (
    <div className={Styles.container}>
      <Searchbar />
      <div className={Styles.tableWrapper}>
        <Table
          data={template?.data}
          totalData={data?.totalData}
          totalPage={3}
          columns={template?.columns}
          page={page}
          setPage={setPage}
          className={`${Styles.table} ${
            !data?.data?.length ? Styles.grow : ""
          }`}
          limit={limit}
          setLimit={setLimit}
          withNumbering
        />
      </div>
    </div>
  );
}
